(function () {
    'use strict';

    angular
        .module('actionPlanModule')
        .directive('grcActionPlan', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addActionPlan = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller', 'recomConstants', 'modalService', function ($scope, $controller, recomConstants, modalService) {
                // set feature role if it is on object.
                if ($scope.boxModel && $scope.boxModel.RecomBusinessUnit && $scope.boxModel.RecomBusinessUnit.FeatureRole){
                    $scope.boxFeatureRole = $scope.boxModel.RecomBusinessUnit.FeatureRole;
                }

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/actionPlan/grcActionPlan.[Template].tpl.html';
                $scope.boxFeatureRole = $scope.boxFeatureRole || recomConstants.featureRoles;
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'ActionPlan';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.readOnly = !$scope.boxPermissions.Edit;

                // Open Action Plan Comments
                $scope.openActionPlanComments = function() {
                    modalService.op
                }
            }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();